import {createContext} from 'react'

function noop() {}

export const AuthContext = createContext({
  superUser: null,
  rootFolder: null,
  avatarLink: null,
  accessToken: null,
  refreshToken: null,
  userId: null,
  nickName: null,
  language: null,
  login: noop,
  logout: noop,
  isAuthenticated: false,
  deviceId: null,
  authenticatedVia: null
})
